// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___31hMh","active":"style__active___IUbbc","small":"style__small___1MoqS","normal":"style__normal___rrD2G","large":"style__large___ZV-jw","title":"style__title___2LhbW","body":"style__body___1warV","navigation":"style__navigation___15_De","button":"style__button___2f6H8"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox/lib/dialog/style.scss
 ** module id = 375
 ** module chunks = 0
 **/